import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-modal sidebarmodal sidebarmodal-backdrop align-center grid grid-cols-12" }
const _hoisted_2 = ["data-test"]
const _hoisted_3 = {
  key: 0,
  class: "sidebarmodal-header-wrapper tw-flex-none s-pl-5 s-pr-6 s-pt-5 s-pb-4 bg-core-primary-100"
}
const _hoisted_4 = { class: "sidebarmodal-body tw-flex-1 s-pl-5 s-pr-6 s-pt-4 s-pb-4" }
const _hoisted_5 = {
  key: 0,
  "data-test": "modal-loading",
  class: "modal-loading"
}
const _hoisted_6 = { class: "buttons-center tw-flex tw-gap-4 tw-justify-center" }

import Loading from 'frontcore/components/loadings/Loading.vue'
import ModalHeader from 'frontcore/views/modals/ModalHeader.vue'
import { computed, onBeforeUnmount, onMounted, PropType } from 'vue'
import { PORTAL_LEVELS } from 'frontcore/constants/constants'
import { SidebarHeader } from 'frontcore/views/modals/types'


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarModal',
  props: {
  // Use this prop to add a class to the modal
  // Here you can use this to define the width of the modal through classes
  // Example : modalClass="col-start-2 col-span-10"
  modalClass: {
    type: String,
    required: false,
    default: 'col-start-1 col-span-12 sm:col-start-8 sm:col-span-5 xxl:col-start-9 xxl:col-span-4',
  },
  portalTarget: {
    type: String,
    default: PORTAL_LEVELS.ONE,
  },
  header: {
    type: Object as unknown as PropType<SidebarHeader>,
    default: null,
  },
  footerClass: {
    type: String,
    required: false,
  },
  modalContentClass: {
    type: String,
    required: false,
  },
  dataTest: {
    type: String,
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const onCloseHandler = () => {
  const header = props.header
  if (header?.onCloseHandler !== undefined && !props.loading) {
    header.onCloseHandler()
  }
}

const modalAttrs = computed(() => {
  return {
    class: 'modal-native',
    to: props.portalTarget,
    tag: 'div',
  }
})

onMounted(() => {
  document.body.classList.add('overflow-hidden')
})

onBeforeUnmount(() => {
  document.body.classList.remove('overflow-hidden')
})

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent("portal"), _normalizeProps(_guardReactiveProps(modalAttrs.value)), {
    default: _withCtx(() => [
      _createElementVNode("dialog", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("article", {
          class: _normalizeClass(["sidebarmodal-dialog", __props.modalClass]),
          "data-test": __props.dataTest
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([__props.modalContentClass, "sidebarmodal-content tw-flex tw-flex-col tw-h-screen bg-core-primary-100"])
          }, [
            _renderSlot(_ctx.$slots, "sidebarmodal-header", {}, () => [
              (__props.header)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(ModalHeader, {
                      iconName: __props.header.iconName,
                      dataTest: __props.header.dataTest,
                      title: __props.header.title,
                      onClose: onCloseHandler
                    }, null, 8, ["iconName", "dataTest", "title"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_Transition, { name: "modal-content" }, {
                default: _withCtx(() => [
                  (!__props.loading)
                    ? _renderSlot(_ctx.$slots, "body", { key: 0 })
                    : _createCommentVNode("", true)
                ], undefined, true),
                _: 3
              }),
              _createVNode(_Transition, {
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (__props.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(Loading)
                      ]))
                    : _createCommentVNode("", true)
                ], undefined, true),
                _: 1
              })
            ]),
            _createElementVNode("div", {
              class: _normalizeClass([__props.footerClass, "sidebarmodal-footer tw-flex-none tw-px-6 tw-pb-6 tw-pt-4"])
            }, [
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "footer")
              ])
            ], 2)
          ], 2)
        ], 10, _hoisted_2)), [
          [_directive_click_outside, onCloseHandler]
        ])
      ])
    ], undefined, true),
    _: 3
  }, 16))
}
}

})